<template>
	<div class="dialog-start-game">
		<div class="dialog-start-game__texts">
			<div>
				<h1>Ready to play</h1>
				<h1><span class="text-sunset-coral">Rock</span>, <span class="text-teal-tide">Paper</span>, <span class="text-bahay-kubo">Scissors</span>?</h1>
			</div>
			<div>
				<p class="heading-4">Make your move!</p>
				<p class="text-gray-6">The first player to score 5 points wins the game!</p>
			</div>
		</div>

		<select-rock-paper-scissors
			:selected-answer="null"
			@selected="handleSelectedOption" />
	</div>
</template>

<script>
	import SelectRockPaperScissors from '@/components/select-rock-paper-scissors.vue';

	export default {
		name: 'dialog-start-game',
		components: { SelectRockPaperScissors },
		methods: {
			handleSelectedOption(opt) {
				this.$modal.close(opt);
			},
		},
	};
</script>

<style lang="scss">
	.dialog-start-game {
		@extend %layout-flex-center-y;
		gap: 32px;
		background: linear-gradient(rgba(color('coral-blush'), 0.5), rgba(color('coral-blush'), 0.5)), color('white');
		padding: 32px;
		min-width: 784px;
		border: 8px solid color('soft-cream');

		@include responsive('827px') {
			min-width: 100%;
		}

		@include responsive(small) {
			padding: 28px;
		}

		h1 {
			font-weight: var(--font-weight-black);

			@include responsive($mobile-size) {
				font-size: 40px;
				line-height: 46.96px;
			}
		}

		&__texts {
			@extend %flex-column;
			gap: 16px;
			text-align: center;

			@include responsive($mobile-size) {
				.heading-4 {
					font-size: 23px;
					line-height: 27px;
				}

				p.text-gray-6 {
					font-size: 16px;
					line-height: 18.78px;
				}
			}
		}
	}
</style>
